var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../box/Box";
import { Transition } from "react-transition-group";
var duration = 400;
var defaultStyle = {
    transition: "width " + duration + "ms cubic-bezier(0, 0, 0,1)",
    width: "0%",
};
var ProgressBar = function (_a) {
    var percent = _a.percent, _b = _a.barColor, barColor = _b === void 0 ? "sunwashGolds.4" : _b, _c = _a.barBgColor, barBgColor = _c === void 0 ? "sunwashGolds.1" : _c, _d = _a.height, height = _d === void 0 ? "6px" : _d, _e = _a.animateOnMount, animateOnMount = _e === void 0 ? true : _e, rest = __rest(_a, ["percent", "barColor", "barBgColor", "height", "animateOnMount"]);
    var transitionStyles = {
        entering: { width: "0%" },
        entered: { width: percent + "%" },
        exiting: { width: "0%" },
        exited: { width: "0%" },
    };
    return (React.createElement(Box, __assign({ width: "100%", height: height, bg: barBgColor, overflow: "hidden" }, rest),
        React.createElement(Transition, { in: true, appear: animateOnMount, timeout: duration }, function (state) { return (React.createElement(Box, { bg: barColor, height: height, style: __assign(__assign({}, defaultStyle), transitionStyles[state]) })); })));
};
export default ProgressBar;
//# sourceMappingURL=ProgressBar.js.map